import {
  AbNode,
  AbElementNode,
  ActionNode,
  ConnectorNode,
  ConnectorElementNode,
  TimerNode,
  TriggerNode,
  ComponentType,
  Node,
  PartialNodeProps
} from '../types'

type NodeIteratee = (
  node: Node,
  context: NodeIterateeContext
) => boolean | void

interface NodeIterateeContext {
  parent: Node | null;
  parentChildCount: number
  index: number
  isFirstChild: boolean
  isMiddleChild: boolean
  isLastChild: boolean
  children: Node[]
  siblings: Node[]
  depth: number
}

function _walkNode(
  node: Node,
  parent: Node | null,
  depth: number,
  iteratee: NodeIteratee
): boolean | undefined {
  const index = parent ? parent.nextComponents.indexOf(node) : 0
  const parentChildCount = parent ? parent.nextComponents.length : 0
  const isFirstChild = (index === 0)
  const isMiddleChild = (index > 0 && index < parentChildCount - 1)
  const isLastChild = (index === parentChildCount - 1)
  const children = node.nextComponents
  const siblings = parent ? parent.nextComponents.filter(d => d !== node) : []
  const context: NodeIterateeContext = {
    parent,
    parentChildCount,
    index,
    isFirstChild,
    isMiddleChild,
    isLastChild,
    siblings,
    children,
    depth
  }
  if (iteratee(node, context) === false) {
    return false
  }
  for (const child of node.nextComponents) {
    if (_walkNode(child, node, depth + 1, iteratee) === false) {
      return false
    }
  }
}

export function walkNode(node: Node, iteratee: NodeIteratee) {
  _walkNode(node, null, 0, iteratee)
}
